"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Instagram, Facebook, Twitter, MapPin, Phone, Mail } from "lucide-react";
function FooterNav() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-4">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-4 w-24 bg-muted animate-pulse rounded-sm" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  return <ul className="flex flex-col gap-4">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors font-default text-sm md:text-base">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const socialLinks = [{
    icon: Instagram,
    label: "Instagram",
    to: "#"
  }, {
    icon: Facebook,
    label: "Facebook",
    to: "#"
  }, {
    icon: Twitter,
    label: "Twitter",
    to: "#"
  }];
  return <footer data-section-id="229994" id="footer" className="dark bg-background text-foreground pt-20 pb-10 px-6 md:px-12 lg:px-24">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-16 md:gap-12 lg:gap-24">
          
          {}
          <div className="flex flex-col items-start gap-8">
            <Link to="/HomePage">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1655661/img/peachtree_post_logo_footer.png" alt="The Peachtree Post Logo" className="h-7 w-auto object-contain" />
            </Link>
            <p className="text-muted-foreground font-default text-sm leading-relaxed max-w-xs">
              Premium co-op direct mail marketing connecting trusted local businesses with high-income households across Metro Atlanta.
            </p>
          </div>

          {}
          <div className="flex flex-col items-start gap-8">
            <h3 className="font-default text-lg font-semibold tracking-wider uppercase text-foreground">
              Navigation
            </h3>
            <MenuProvider menu_id="17">
              <FooterNav />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col items-start gap-8">
            <h3 className="font-default text-lg font-semibold tracking-wider uppercase text-foreground">
              Get In Touch
            </h3>
            <div className="flex flex-col gap-4 text-muted-foreground font-default text-sm md:text-base">
              <div className="flex items-start gap-3">
                <MapPin className="size-5 shrink-0 text-primary mt-0.5" strokeWidth={1.5} />
                <span>Johns Creek, Metro Atlanta, GA</span>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="size-5 shrink-0 text-primary" strokeWidth={1.5} />
                <span>(404) 555-0192</span>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="size-5 shrink-0 text-primary" strokeWidth={1.5} />
                <span>hello@peachtreepost.com</span>
              </div>
            </div>

            <div className="flex items-center gap-6 mt-2">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Link key={social.label} to={social.to} data-index={i} className="text-muted-foreground hover:text-primary transition-all hover:scale-110" aria-label={social.label}>
                    <Icon className="size-6" strokeWidth={1.5} />
                  </Link>;
            })}
            </div>
          </div>

        </div>

        {}
        <div className="h-px w-full bg-gradient-to-r from-transparent via-primary/30 to-transparent my-16" />

        {}
        <div className="flex justify-center items-center">
          <p className="text-[10px] tracking-widest uppercase text-muted-foreground/60 font-default">
            &copy; {currentYear} THE PEACHTREE POST. ALL RIGHTS RESERVED.
          </p>
        </div>
      </div>
    </footer>;
}